
import UiIcon from "@/components/UI/UiIcon.vue";

export default {
  name: "SearchNoResults",
  components: {
    UiIcon,
  },
};
